import React from 'react';

export const GlobalNavProfile = React.lazy(() =>
  import(
    /* webpackChunkName: "GlobalNavProfile" */
    "./cms-components/nav/GlobalNavProfile"
  )
);
export const ProductComparison = React.lazy(() =>
  import(
    /* webpackChunkName: "ProductComparison" */
    "./cms-components/calculators/ProductComparison"
  )
);
export const Careers = React.lazy(() =>
  import(
    /* webpackChunkName: "Careers" */
    "./cms-components/careers/Careers"
  )
);
export const BannerComponentContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "BannerComponentContainer" */
    "./cms-components/banner/BannerComponentContainer"
  )
);
export const CheckEmailComponentContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "CheckEmailComponentContainer" */
    "./cms-components/check-email/CheckEmailComponentContainer"
  )
);
export const DemoComponentContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "DemoComponentContainer" */
    "./cms-components/demo/DemoComponentContainer"
  )
);

export const MegaCalculatorContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "MegaCalculatorContainer" */
    "./cms-components/pricing-calculator/MegaCalculatorContainer"
  )
);
export const PriceFinderContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "PriceFinderContainer" */
    "./cms-components/pricing-calculator/PriceFinderContainer"
  )
);
export const PricingExampleContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "PricingExampleContainer" */
    "./cms-components/pricing-calculator/PricingExampleContainer"
    )
);
export const PricingCalculatorContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "PricingCalculatorContainer" */
    "./cms-components/pricing-calculator/PricingCalculatorContainer"
  )
);
export const PricingPageContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "PricingPageContainer" */
    "./cms-components/pricing-calculator/PricingPageContainer"
  )
);
export const PricingCalculatorRichText = React.lazy(() =>
  import(
    /* webpackChunkName: "PricingCalculatorRichText" */
    "./cms-components/pricing-calculator/PricingCalculatorRichText"
  )
);
export const WacSiteRenameFormContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "WacSiteRenameFormContainer" */
    "./cms-components/site-rename/WacSiteRenameFormContainer"
  )
);
export const ProductTemplateSiteSelectorContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "ProductTemplateSiteSelectorContainer" */
    "./cms-components/product/ProductTemplateSiteSelectorContainer"
  )
);
export const ProductTemplateSiteSelectorViewContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "ProductTemplateSiteSelectorViewContainer" */
    "./cms-components/product/ProductTemplateSiteSelectorViewContainer"
  )
);
export const QrcodeComponentContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "QrcodeComponentContainer" */
    "./cms-components/qrcode/QrcodeComponentContainer"
  )
);
export const ConfigurableQuizContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "ConfigurableQuizContainer" */
    "./cms-components/configurable-quiz/ConfigurableQuizContainer"
  )
);
export const MiniQuizContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "MiniQuiz" */
    "./cms-components/mini-quiz/MiniQuizContainer"
  )
);
export const WacSignUpLayoutContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "WacSignUpLayoutContainer" */
    "./sign-up-layout/WacSignUpLayoutContainer"
  )
);
export const GlobalNavDropdown = React.lazy(() =>
  import(
    /* webpackChunkName: "GlobalNavDropdown" */
    "./cms-components/nav/GlobalNavDropdown"
  )
);
export const TemplateCardGenerator = React.lazy(() =>
  import(
    /* webpackChunkName: "TemplateCardGenerator" */
    "./cms-components/showroom/TemplateCardGenerator"
  )
);
export const WacFreeBundlesContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "WacFreeBundlesContainer" */
    "./cms-components/wac-free-bundles/WacFreeBundlesContainer"
  )
);
export const EctlListComponentContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "EctlListComponentContainer" */
    "./cms-components/ectl-list/EctlListComponentContainer"
  )
);
export const SiteSelectionListComponentContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "SiteSelectionListComponentContainer" */
    "./cms-components/site-selection-list/SiteSelectionListComponentContainer"
  )
);
export const WacCheckEmailPageContainer = React.lazy(() => import(
  /* webpackChunkName: "WacCheckEmailPageContainer" */
  "./cms-components/wac-check-email-page/WacCheckEmailPageContainer"));
export const WacConfirmationPageContainer = React.lazy(() => import(
  /* webpackChunkName: "WacConfirmationPageContainer" */
  "./cms-components/wac-confirmation-page/WacConfirmationPageContainer"));
export const WacAppProvisionContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "WacAppProvisionContainer" */
    "./cms-components/wac-app-provision/WacAppProvisionContainer"
  )
);
export const WacCartPrototypeContainer = React.lazy(() =>
  import(
    /* webpackChunkName: "WacCartPrototypeContainer" */
    "./cms-components/wac-cart-prototype/WacCartPrototypeContainer"
  )
);